import { render, staticRenderFns } from "./report-attentdent.vue?vue&type=template&id=f63477f2&scoped=true"
import script from "./report-attentdent.vue?vue&type=script&lang=js"
export * from "./report-attentdent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63477f2",
  null
  
)

export default component.exports